/* Hot Sleeper Club – product.js: price engine, buy box, gallery, sticky bar, reels, Black Month urgency ("Limited pieces", never a count; no countdown). Uses window.HSC (global.js). */
const HSC = window.HSC;
const util = HSC.util;
const doc = document;
const esc = util.escapeHtml;
const fmt = util.format;
const money = (c) => HSC.money.formatShort(c);
const decode = (s) => {
  if (typeof s !== 'string' || s.indexOf('&') < 0) return s;
  const t = doc.createElement('textarea');
  t.innerHTML = s;
  return t.value;
};
const define = (name, cls) => { if (!customElements.get(name)) customElements.define(name, cls); };

/* ---------- price engine (CONTRACT §6) ---------- */
HSC.price = HSC.price || {
  compute(unitPrices, promo) {
    const list = (unitPrices || []).map(Number).filter((n) => !Number.isNaN(n));
    const qty = list.length;
    const gross = list.reduce((a, b) => a + b, 0);
    const free = promo ? list.slice().sort((a, b) => a - b).slice(0, Math.floor(qty / 2)).reduce((a, b) => a + b, 0) : 0;
    const total = gross - free;
    return { qty, gross, free, total, each: qty ? Math.round(total / qty) : 0, saving: free };
  },
  tokens({ unitPrice, promo, tier = 1, stateBSaving = 0 }) {
    const u = Number(unitPrice) || 0;
    const pair = promo ? u : u * 2;
    const four = promo ? u * 2 : u * 4;
    const saving = promo ? (tier === 2 ? u * 2 : u) : Number(stateBSaving) || 0;
    return {
      price_single: money(u), price_pair: money(pair), value_pair: money(u * 2), price_four: money(four),
      value_four: money(u * 4), each: money(Math.round(pair / 2)), saving: money(saving)
    };
  },
  updateTokens(scope, tokens) {
    util.qsa('[data-price-token]', scope || doc).forEach((el) => {
      if (el.closest('[data-token-static]')) return;
      const k = el.dataset.priceToken;
      if (tokens && k in tokens && el.textContent !== tokens[k]) el.textContent = tokens[k];
    });
  }
};

function randomId() {
  try { return crypto.randomUUID().slice(0, 8); } catch (e) { return Math.random().toString(36).slice(2, 10); }
}
function listJoin(items, and) {
  if (items.length < 2) return items.join('');
  return `${items.slice(0, -1).join(', ')} ${and} ${items[items.length - 1]}`;
}

/* ---------- <hsc-product>: buy box state for main-product and featured-product ---------- */
class HscProduct extends HTMLElement {
  connectedCallback() {
    const json = this.querySelector('script[data-hsc-product]');
    if (!json) return;
    try { this.data = JSON.parse(json.textContent); } catch (e) { return; }
    this.sid = this.dataset.sectionId;
    this.s = {};
    Object.entries(this.data.strings || {}).forEach(([k, v]) => { this.s[k] = k.endsWith('_html') ? v : decode(v); });
    this.variants = new Map(this.data.variants.map((v) => [v.id, v]));
    this.colorOrder = [];
    this.data.variants.forEach((v) => { if (!this.colorOrder.includes(v.color)) this.colorOrder.push(v.color); });
    this.promo = Boolean(this.data.promo_active);
    this.form = this.querySelector('form[data-product-form]');
    this.atc = this.querySelector('[data-atc]');
    this.gallery = this.querySelector('hsc-gallery');
    const tierInput = this.querySelector('input[data-tier]:checked');
    this.tier = tierInput ? Number(tierInput.dataset.tier) : (this.promo ? 1 : 0);
    this.tierQty = tierInput ? Number(tierInput.dataset.qty) : (this.promo ? 2 : 1);
    this.color = this.data.selected_variant_id;
    this.units = [this.color, this.color, this.color, this.color];
    this.galleryColor = (this.variants.get(this.color) || {}).color_handle;
    this.notes = {};
    if (this.hasAttribute('data-update-url')) this.readParams();
    this.fixUnits();
    this.bind();
    this.render('init');
    this.onHash = () => {
      if (window.location.hash !== '#notify' || !this.hasAttribute('data-update-url') || !this.state || !this.state.soldOut) return;
      HSC.dialog.closeAll({ returnFocus: false, immediate: true });
      this.openNotify();
    };
    window.addEventListener('hashchange', this.onHash);
    this.onHash();
    if (HSC.promo && this.promo !== HSC.promo.isActive()) this.refetch();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onChange);
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('submit', this.onSubmit);
    this.removeEventListener('pointerover', this.onPrefetch);
    this.removeEventListener('focusin', this.onPrefetch);
    this.removeEventListener('touchstart', this.onPrefetch);
    this.removeEventListener('toggle', this.onToggle, true);
    if (this.onHash) window.removeEventListener('hashchange', this.onHash);
    if (this.offPromo) this.offPromo();
    if (this.offCartUpdated) this.offCartUpdated();
    if (this.onVisible) doc.removeEventListener('visibilitychange', this.onVisible);
    clearTimeout(this.stockTimer);
    if (this.io) this.io.disconnect();
    if (this.statusTimer) clearTimeout(this.statusTimer);
  }

  readParams() {
    const p = new URLSearchParams(window.location.search);
    const ids = (p.get('units') || '').split(',').map(Number).filter(Boolean);
    if ((ids.length === 2 || ids.length === 4) && ids.every((id) => this.isOrderable(this.variants.get(id)))) {
      const t = ids.length === 4 ? 2 : 1;
      if (this.tierInput(t) && !this.tierInput(t).disabled) {
        this.setTierState(t);
        ids.forEach((id, i) => { this.units[i] = id; });
        this.color = ids[ids.length - 1];
      }
    }
    const tier = p.get('tier');
    if ((tier === '1' || tier === '2') && !p.get('units')) {
      const input = this.tierInput(Number(tier));
      if (input && !input.disabled) this.setTierState(Number(tier));
    }
  }

  bind() {
    this.onChange = (e) => {
      const t = e.target;
      if (t.matches('[data-swatch]')) this.setColor(Number(t.dataset.variantId), 'swatch');
      else if (t.matches('[data-tier]')) this.setTier(Number(t.dataset.tier));
      else if (t.matches('[data-unit]')) this.setUnit(Number(t.dataset.unit), Number(t.dataset.variantId));
      else if (t.name === `pairs-${this.sid}`) {
        const add = this.querySelector('[data-pairs-add]');
        const price = this.querySelector('[data-pairs-price]');
        if (add) add.dataset.variantId = t.value;
        if (price && t.dataset.price) price.textContent = t.dataset.price;
      }
    };
    this.onClick = (e) => {
      const t = e.target;
      /* click fires before change: an already-checked swatch never gets a change event (SPEC D.7 / D.9 #3) */
      if (t.matches && t.matches('input[data-swatch]') && this.state && this.state.sum && this.state.sum.mixed
        && Number(t.dataset.variantId) === this.state.main.id) {
        this.setColor(this.state.main.id, 'swatch');
        return;
      }
      const single = t.closest('[data-single-add]');
      if (single) { e.preventDefault(); this.submit(single, { single: true }); return; }
      const notify = t.closest('[data-notify-open]');
      if (notify) { e.preventDefault(); this.openNotify(notify); return; }
      /* plan N1: "Notify me when it's back" under the sold-out price row (also works when #notify is already the hash) */
      const notifyLink = t.closest('[data-notify-link]');
      if (notifyLink) { e.preventDefault(); this.openNotify(); return; }
      const pick = t.closest('[data-select-first-available]');
      if (pick) { e.preventDefault(); this.selectFirstAvailable(); return; }
      const notifyColor = t.closest('[data-notify-variant]');
      if (notifyColor) { e.preventDefault(); this.setColor(Number(notifyColor.dataset.notifyVariant), 'swatch'); this.openNotify(); return; }
      const mix = t.closest('[data-mix-colors]');
      if (mix) {
        const rows = doc.getElementById(mix.getAttribute('aria-controls'));
        if (rows) rows.hidden = false;
        mix.setAttribute('aria-expanded', 'true');
        const row = mix.closest('[data-compact]');
        if (row) row.hidden = true;
        const first = rows && rows.querySelector('input:checked');
        if (first) first.focus();
        return;
      }
      const pairs = t.closest('[data-pairs-add]');
      if (pairs) { e.preventDefault(); this.addPairs(pairs); }
    };
    this.onSubmit = (e) => {
      if (e.target === this.form) { e.preventDefault(); this.submit(this.atc); }
      else if (e.target.matches('[data-bis-form]')) this.submitBis(e);
    };
    this.onPrefetch = (e) => {
      const t = e.target;
      const label = t.closest && t.closest('[data-swatch-label]');
      const handle = label ? label.dataset.swatchLabel : (t.matches && t.matches('[data-swatch]') ? t.dataset.colorHandle : '');
      if (handle && this.gallery && this.gallery.prefetch) this.gallery.prefetch(handle);
    };
    this.onToggle = (e) => {
      if (e.target.matches && e.target.matches('[data-popover]') && e.newState === 'open') e.target.focus();
    };
    this.addEventListener('change', this.onChange);
    this.addEventListener('click', this.onClick);
    this.addEventListener('submit', this.onSubmit);
    this.addEventListener('pointerover', this.onPrefetch);
    this.addEventListener('focusin', this.onPrefetch);
    this.addEventListener('touchstart', this.onPrefetch, { passive: true });
    this.addEventListener('toggle', this.onToggle, true);
    this.offPromo = HSC.bus.on('promo:change', () => this.refetch(true));
    /* Black Month urgency: fresh inventory after a cart change and when the tab comes back after 5 minutes (other
       shoppers' orders), at most once a minute, so a color sold out meanwhile is struck and loses "Limited pieces" */
    this.loadedAt = Date.now();
    this.stockAt = 0;
    this.offCartUpdated = HSC.bus.on('cart:updated', (d) => {
      if (d && d.source === 'refresh') return;
      clearTimeout(this.stockTimer);
      this.stockTimer = setTimeout(() => this.refreshStock(), 1500);
    });
    this.onVisible = () => { if (doc.visibilityState === 'visible' && Date.now() - Math.max(this.stockAt, this.loadedAt) >= 300000) this.refreshStock(); };
    doc.addEventListener('visibilitychange', this.onVisible);
    const box = this.querySelector('[data-delivery-box]');
    if (box && 'IntersectionObserver' in window) {
      this.io = new IntersectionObserver((entries) => {
        if (entries.some((en) => en.isIntersecting)) { HSC.trackOnce('hsc_delivery_box_view', {}); this.io.disconnect(); }
      }, { threshold: 0.5 });
      this.io.observe(box);
    }
  }

  async refetch(force) {
    HSC.state.pdpRefetched = HSC.state.pdpRefetched || {};
    if (HSC.state.pdpRefetched[this.sid] && !force) return;
    HSC.state.pdpRefetched[this.sid] = true;
    try {
      const sections = await HSC.sections.fetch([this.sid], window.location.pathname + window.location.search);
      HSC.sections.apply(sections);
    } catch (e) {
      /* red-team 26.10.2026: without a fresh section the price row, the sticky bar and the button still follow the
         offer state, so an open or cached page never shows "50% OFF" / "You save" next to a total the cart won't charge */
      HSC.promo.apply(this);
      const active = HSC.promo.isActive();
      if (this.promo !== active) {
        this.promo = active;
        this.render('promo');
      }
    }
  }

  /* ----- Black Month urgency (owner decision 13): "Limited pieces" is the only scarcity wording, never a number.
     It shows while the master gate of snippets/limited-pieces is on and the selected color is in stock. ----- */
  piecesOn(soldOut) {
    return Boolean(this.data.urgency && this.data.urgency.pieces && !soldOut);
  }
  renderPieces(show) {
    util.qsa('[data-pieces]', this).forEach((el) => { el.hidden = !show; });
    if (show) HSC.trackOnce('hsc_limited_pieces_view', {});
  }
  /** Plan N9 (F7): fresh stock flags without re-rendering the whole product section: about 1 KB from sections/stock-json
      on the clean product URL (no ad parameters, qty capped at 8, never shown). Falls back to the product section
      render when that answer is missing. Returns [{ id, available, qty }] or null. */
  async fetchStock() {
    const base = this.data.url || window.location.pathname;
    try {
      const res = await util.fetchWithTimeout(`${base}${base.includes('?') ? '&' : '?'}section_id=stock-json`, { headers: { Accept: 'text/html' } });
      if (res.ok) {
        const el = new DOMParser().parseFromString(await res.text(), 'text/html').querySelector('script[data-stock]');
        const list = el ? JSON.parse(el.textContent) : null;
        if (Array.isArray(list) && list.length) return list;
      }
    } catch (e) { /* fall back to the section render */ }
    const sections = await HSC.sections.fetch([this.sid], window.location.pathname + window.location.search);
    const html = sections && sections[this.sid];
    const json = html && new DOMParser().parseFromString(html, 'text/html').querySelector('script[data-hsc-product]');
    const fresh = json ? JSON.parse(json.textContent) : null;
    return fresh && Array.isArray(fresh.variants) ? fresh.variants : null;
  }

  /** Fresh inventory through the Section Rendering API (the cart never holds stock on Shopify). */
  async refreshStock() {
    if (this.stockBusy) return;
    /* at most once a minute: a throttled check is rescheduled, never dropped (the first one after load runs at once) */
    const wait = 60000 - (Date.now() - (this.stockAt || 0));
    if (wait > 0) { clearTimeout(this.stockTimer); this.stockTimer = setTimeout(() => this.refreshStock(), wait); return; }
    this.stockBusy = true;
    try {
      const list = await this.fetchStock();
      if (!list) return;
      const gone = [];
      let changed = false;
      list.forEach((fv) => {
        const v = this.variants.get(fv.id);
        if (!v || (v.qty === fv.qty && v.available === fv.available)) return;
        if (this.isOrderable(v) && !(fv.available && (fv.qty == null || fv.qty > 0))) gone.push(v.color);
        v.qty = fv.qty; v.available = fv.available; changed = true;
      });
      if (changed) { this.fixUnits(); this.render('stock'); }
      if (gone.length && this.s.sold_out_now) HSC.announce(fmt(this.s.sold_out_now, { color: listJoin(gone, this.s.and) }));
    } catch (e) { /* keep the known stock */ } finally {
      this.stockAt = Date.now();
      this.stockBusy = false;
    }
  }

  /* ----- stock helpers ----- */
  stock(v) { if (!v || !v.available) return 0; return v.qty == null ? Infinity : Math.max(0, v.qty); }
  isOrderable(v) { return Boolean(v && this.stock(v) > 0); }
  totalStock() { return this.data.variants.reduce((a, v) => a + this.stock(v), 0); }
  tierInput(t) { return this.querySelector(`input[data-tier="${t}"]`); }
  countOf(id, units, skip) { return units.reduce((a, u, i) => a + (u === id && i !== skip ? 1 : 0), 0); }
  /** Units of a variant already in the cart (HSC.cart.state, refreshed after every add). */
  inCart(id) {
    const st = HSC.cart && HSC.cart.state;
    if (!st || !Array.isArray(st.items)) return 0;
    return st.items.reduce((a, it) => a + (Number(it.variant_id || it.id) === id ? Number(it.quantity) || 0 : 0), 0);
  }
  /** First unit that would exceed the stock once the cart's units of that color are counted (SPEC M.2 #12, F.3). */
  cartConflict(ids) {
    const used = new Map();
    for (let i = 0; i < ids.length; i++) {
      const v = this.variants.get(ids[i]);
      if (!v) continue;
      const c = (used.get(v.id) || 0) + 1;
      used.set(v.id, c);
      const stock = this.stock(v);
      const held = this.inCart(v.id);
      /* qty is capped at 8 in the page (plan N9): at the cap the real stock may be higher, so Shopify's own answer decides */
      if (stock !== Infinity && !(v.qty >= 8) && c + held > stock) return { index: i, variant: v, left: Math.max(0, stock - held) };
    }
    return null;
  }
  showCartConflict(conflict) {
    const v = conflict.variant;
    const count = conflict.left > 0 ? conflict.left : this.stock(v);
    const tpl = this.s.cart_stock_error || this.s.stock_note;
    this.notes = { error: conflict.index, text: fmt(tpl, { count, color: v.color, index: conflict.index + 1 }) };
    this.render('validate');
    this.focusUnit(conflict.index);
  }

  fixUnits() {
    const n = this.tierQty;
    const used = new Map();
    for (let i = 0; i < n; i++) {
      let v = this.variants.get(this.units[i]);
      if (!v || (used.get(v.id) || 0) >= this.stock(v)) {
        const alt = this.colorOrder.map((c) => this.data.variants.find((x) => x.color === c && (used.get(x.id) || 0) < this.stock(x))).find(Boolean);
        if (alt) { this.units[i] = alt.id; v = alt; }
      }
      if (v) used.set(v.id, (used.get(v.id) || 0) + 1);
    }
  }

  firstInvalid() {
    const used = new Map();
    for (let i = 0; i < this.tierQty; i++) {
      const v = this.variants.get(this.units[i]);
      const c = (used.get(this.units[i]) || 0) + 1;
      used.set(this.units[i], c);
      if (!this.isOrderable(v) || c > this.stock(v)) return i;
    }
    return -1;
  }

  /* ----- state changes ----- */
  setColor(id, source) {
    const v = this.variants.get(id);
    if (!v) return;
    this.color = id;
    this.notes = {};
    if (this.isOrderable(v)) {
      let left = this.stock(v);
      for (let i = 0; i < this.tierQty; i++) {
        if (left > 0) { this.units[i] = id; left--; }
        else if (this.notes.stock == null) this.notes.stock = i;
      }
      for (let i = this.tierQty; i < 4; i++) this.units[i] = this.units[i % this.tierQty];
      if (this.notes.stock != null) {
        this.fixUnits();
        this.notes.stockColor = v;
      }
    }
    this.render(source);
  }

  /** Plan N1: "Other colors are in stock." selects the first orderable color (Sky Blue → Sand → Blush order). */
  selectFirstAvailable() {
    const v = this.colorOrder.map((c) => this.data.variants.find((x) => x.color === c && this.isOrderable(x))).find(Boolean);
    if (!v) return;
    this.setColor(v.id, 'swatch');
    const sw = this.querySelector(`input[data-swatch][data-variant-id="${v.id}"]`);
    if (sw) sw.focus({ preventScroll: true });
  }

  setUnit(i, id) {
    const v = this.variants.get(id);
    if (!v) return;
    this.units[i] = id;
    this.color = id;
    this.notes = {};
    this.render('unit');
    HSC.track('hsc_unit_color_change', { unit: i + 1, color: v.color });
  }

  setTierState(t) {
    const input = this.tierInput(t);
    if (!input) return;
    const qty = Number(input.dataset.qty);
    for (let i = this.tierQty; i < qty; i++) this.units[i] = this.units[i % this.tierQty];
    this.tier = t;
    this.tierQty = qty;
  }

  setTier(t) {
    this.setTierState(t);
    this.notes = {};
    this.fixUnits();
    this.render('tier');
    HSC.track('hsc_tier_select', { tier: t });
  }

  /* ----- color summary (SPEC D.7) ----- */
  summary(units) {
    const vs = units.map((id) => this.variants.get(id)).filter(Boolean);
    const counts = new Map();
    vs.forEach((v) => counts.set(v.color, (counts.get(v.color) || 0) + 1));
    const ordered = this.colorOrder.filter((c) => counts.has(c));
    const spoken = listJoin(ordered.flatMap((c) => Array(counts.get(c)).fill(c)), this.s.and || '&');
    if (ordered.length <= 1) return { text: ordered[0] || '', spoken, mixed: false };
    if (vs.length === 2) return { text: ordered.join(' + '), spoken, mixed: true };
    const text = ordered.map((c) => (counts.get(c) > 1 ? fmt(this.s.summary_count, { count: counts.get(c), color: c }) : c)).join(', ');
    return { text, spoken, mixed: true };
  }

  /* ----- sale badge ("50% OFF", black in the Black Month theme): same rule as snippets/promo-badge (free amount ÷ gross of the set, else nothing) ----- */
  badgeText(totals) {
    const raw = String(this.data.badge_text || '').trim();
    if (!raw || !(totals.free > 0) || !(totals.gross > 0)) return '';
    const pct = Math.round((totals.free * 100) / totals.gross);
    const text = raw.replace(/\[percent\]/g, String(pct));
    const m = text.match(/(\d+(?:\.\d+)?)\s*%/);
    return m && Number(m[1]) !== pct ? '' : text;
  }

  /* ----- render everything from state ----- */
  render(source) {
    const n = this.tierQty;
    const units = this.units.slice(0, n);
    const vs = units.map((id) => this.variants.get(id)).filter(Boolean);
    const main = this.variants.get(this.color) || vs[0];
    if (!main || !vs.length) return;
    const promo = this.promo;
    const totals = HSC.price.compute(vs.map((v) => v.price), promo);
    const unit = vs[0].price;
    const soldOut = !this.isOrderable(main);
    const invalid = this.firstInvalid();
    const sum = this.summary(units);
    const pre = vs.filter((v) => v.preorder_ship_by).sort((a, b) => (a.preorder_ship_by < b.preorder_ship_by ? 1 : -1))[0] || null;
    const tierWrap = this.querySelector(`[data-tier-wrap="${this.tier}"]`);
    const tierTitle = (this.tierInput(this.tier) && decode(this.tierInput(this.tier).dataset.title)) || '';

    /* swatches */
    util.qsa('input[data-swatch]', this).forEach((input) => {
      const v = this.variants.get(Number(input.dataset.variantId));
      input.checked = Number(input.dataset.variantId) === main.id;
      const label = input.nextElementSibling;
      if (label && v) {
        label.classList.toggle('is-sold-out', !this.isOrderable(v));
        const sold = label.querySelector('[data-swatch-sold]');
        if (sold) sold.hidden = this.isOrderable(v);
      }
    });
    const legend = this.querySelector('[data-swatch-value]');
    if (legend) {
      legend.textContent = soldOut || !sum.mixed ? main.color : sum.text;
      legend.title = soldOut ? main.color : sum.spoken;
    }

    /* tiers */
    const stockAll = this.totalStock();
    util.qsa('[data-tier-wrap]', this).forEach((wrap) => {
      const t = Number(wrap.dataset.tierWrap);
      const input = wrap.querySelector('input[data-tier]');
      const qty = Number(input.dataset.qty);
      const selected = t === this.tier;
      const disabled = stockAll < qty;
      input.checked = selected;
      input.disabled = disabled && !selected;
      wrap.classList.toggle('is-selected', selected);
      wrap.classList.toggle('is-disabled', disabled && !selected);
      const note = wrap.querySelector('[data-tier-note]');
      if (note) note.hidden = !(disabled && !selected);
      const panel = wrap.querySelector('[data-tier-units]');
      if (panel) panel.hidden = !selected;
      const tt = selected ? totals : HSC.price.compute(Array(qty).fill(unit), promo);
      const price = wrap.querySelector('[data-tier-price]');
      if (price) price.textContent = money(tt.total);
      const ref = wrap.querySelector('[data-tier-ref]');
      if (ref && ref.lastChild) ref.lastChild.textContent = ` ${money(tt.gross)}`;
      const qual = wrap.querySelector('[data-tier-qual]');
      if (qual) qual.textContent = fmt(this.s.bundle_qualifier, { count: qty, unit: money(unit) });
      const sub = wrap.querySelector('[data-tier-sub]');
      if (sub && qty > 1) {
        const eachStr = fmt(this.s.sub_each, { each: money(tt.each) });
        sub.textContent = promo && tt.free > 0
          ? fmt(this.s.sub_free, { count: qty, free: Math.floor(qty / 2), each: money(tt.each) }).replace(eachStr, eachStr.replace(/ /g, '\u00a0'))
          : eachStr;
      }
    });

    /* unit chips of the selected tier */
    if (tierWrap) {
      util.qsa('[data-unit-row]', tierWrap).forEach((row) => {
        const i = Number(row.dataset.unitRow);
        util.qsa('input[data-unit]', row).forEach((input) => {
          const id = Number(input.dataset.variantId);
          const v = this.variants.get(id);
          const checked = units[i] === id;
          input.checked = checked;
          input.disabled = !checked && (!this.isOrderable(v) || this.countOf(id, units, i) >= this.stock(v));
          const sold = input.nextElementSibling && input.nextElementSibling.querySelector('[data-chip-sold]');
          if (sold) sold.hidden = this.isOrderable(v);
        });
        const note = row.querySelector('[data-unit-note]');
        const showNote = (this.notes.stock === i || this.notes.error === i);
        if (note) {
          if (showNote && this.notes.text && this.notes.error === i) note.textContent = this.notes.text;
          else if (showNote) {
            const nv = this.notes.stockColor || this.variants.get(units[i]);
            note.textContent = fmt(this.s.stock_note, { count: this.stock(nv) === Infinity ? 0 : this.stock(nv), color: nv.color, index: i + 1 });
          }
          note.hidden = !showNote;
          note.classList.toggle('is-error', this.notes.error === i);
          if (this.notes.error === i) note.setAttribute('role', 'alert'); else note.removeAttribute('role');
        }
        if (this.notes.error === i) row.setAttribute('aria-invalid', 'true'); else row.removeAttribute('aria-invalid');
      });
      const s = tierWrap.querySelector('[data-tier-summary]');
      if (s) { s.hidden = !sum.mixed; s.textContent = sum.text; s.title = sum.spoken; }
      const compact = tierWrap.querySelector('[data-compact-text]');
      if (compact) compact.textContent = n === 2 ? fmt(this.s.both, { color: sum.text }) : fmt(this.s.all_units, { count: n, color: sum.text });
    }

    /* price row. Plan N1 (owner decisions 9, 13): while the selected color or a selected unit is sold out, no struck
       value, no sale badge and no "You save": the black status pill takes the badge's place, the per-blanket line stays */
    const soldSel = soldOut || vs.some((v) => !this.isOrderable(v));
    const othersInStock = this.totalStock() > 0;
    const row = this.querySelector('[data-price-row]');
    if (row) {
      const pl = (k, c) => this.s[`${k}_${c === 1 ? 'one' : 'other'}`];
      let html = `<span class="price-row__now"><span class="visually-hidden">${esc(fmt(pl('total_for_units', n), { count: n }))}</span>${esc(money(totals.total))}</span>`;
      if (soldSel) {
        const soldV = soldOut ? main : vs.find((v) => !this.isOrderable(v));
        const status = othersInStock && soldV && this.s.sold_out_color ? fmt(this.s.sold_out_color, { color: soldV.color }) : this.s.sold_out_status;
        html += `<span class="price-row__status">${esc(status)}</span>`;
      } else if (totals.free > 0) {
        /* theme settings show_pair_strike (default off, FTC 16 CFR 233/251), show_pair_qualifier (the visible "(n × $89)" note,
           off in the store since 26.10.2026; the hidden "Value of …" text always stays) and show_you_save (default on) */
        if (this.data.show_pair_strike === true) {
          html += `<span class="price-row__ref-group" data-promo-only><s class="price-row__ref"><span class="visually-hidden">${esc(fmt(pl('single_value', n), { count: n, unit: money(unit) }))}</span>${esc(money(totals.gross))}</s>`
            + (this.data.show_pair_qualifier === true ? `<span class="price-row__qual" aria-hidden="true">${esc(fmt(this.s.ref_qualifier, { count: n, unit: money(unit) }))}</span>` : '')
            + '</span>';
        }
        const badge = this.badgeText(totals);
        if (badge) html += `<span class="price-row__badge badge badge--sale" data-promo-only>${esc(badge)}</span>`;
        if (this.data.show_you_save !== false) html += `<span class="price-row__save" data-promo-only>${esc(fmt(this.s.you_save, { amount: money(totals.saving) }))}</span>`;
      }
      row.innerHTML = html;
      const bundleBox = row.closest('[data-price-bundle]');
      if (bundleBox) bundleBox.classList.toggle('price-bundle--soldout', soldSel);
      const each = this.querySelector('[data-price-each]');
      if (each) {
        each.textContent = promo && n === 1
          ? fmt(this.s.single_tier_line, { label: each.dataset.promoLabel || '' })
          : fmt(pl('per_unit', n), { count: n, each: money(totals.each) });
      }
    }
    HSC.price.updateTokens(this, HSC.price.tokens({ unitPrice: unit, promo, tier: n === 4 ? 2 : 1, stateBSaving: this.data.state_b_saving }));
    const soldLinks = this.querySelector('[data-price-soldout]');
    if (soldLinks) {
      soldLinks.hidden = !soldSel;
      const pickBtn = soldLinks.querySelector('[data-select-first-available]');
      if (pickBtn) pickBtn.hidden = !(soldSel && othersInStock);
      /* QA 26.10.2026 (fix 8): the button names the colors that can be ordered, "Shop Sand or Blush" */
      const shopText = pickBtn && pickBtn.querySelector('[data-shop-colors]');
      if (shopText && soldSel && othersInStock && this.s.shop_colors) {
        const soldV = soldOut ? main : vs.find((v) => !this.isOrderable(v));
        const names = this.colorOrder.filter((c) => (!soldV || c !== soldV.color) && this.data.variants.some((x) => x.color === c && this.isOrderable(x)));
        if (names.length) shopText.textContent = fmt(this.s.shop_colors, { colors: listJoin(names, this.s.or || 'or') });
      }
    }
    /* plan N1: the gallery sale tag follows the selected color (the wrapper carries hidden, the tag keeps data-promo-only) */
    util.qsa('[data-sale-chip]', this).forEach((el) => { el.hidden = soldSel; });

    /* Black Month urgency: "Limited pieces" in the offer box (no low-stock line, no count: owner decision 13) */
    const pieces = this.piecesOn(soldOut);
    this.renderPieces(pieces);

    /* buttons */
    const notify = this.querySelector('[data-notify-open]');
    if (this.atc) {
      this.atc.hidden = soldOut;
      const label = this.atc.querySelector('[data-atc-label]');
      /* "Add 2 blankets – $89" (CRO 26.10.2026: the set size in the button, so $89 never reads as one blanket) */
      const addTpl = (n === 1 ? this.s.add_units_one : this.s.add_units_other) || this.s.add_to_cart_price;
      if (label) label.textContent = pre ? fmt(this.s.preorder_price, { price: money(totals.total) }) : fmt(addTpl, { count: n, price: money(totals.total) });
    }
    if (notify) notify.hidden = !soldOut;
    /* a sold-out color selected: "Add a single blanket" would add another color, so it waits (owner 25.10) */
    util.qsa('.bundle-picker__single', this).forEach((el) => el.classList.toggle('is-soldout', soldOut));
    const soldBox = this.querySelector('[data-soldout]');
    if (soldBox) {
      const others = this.totalStock() > 0;
      soldBox.hidden = !soldOut;
      const soldTitle = soldBox.querySelector('[data-soldout-title]');
      if (soldTitle) soldTitle.textContent = others ? fmt(this.s.sold_out_color, { color: main.color }) : this.s.sold_out_status;
      const soldOthers = soldBox.querySelector('[data-soldout-others]');
      if (soldOthers) soldOthers.hidden = !others;
    }
    const preNote = this.querySelector('[data-preorder-note]');
    if (preNote) {
      preNote.hidden = !pre || soldOut;
      if (pre) preNote.innerHTML = fmt(this.s.preorder_note_html, { date: esc(pre.preorder_label || pre.preorder_ship_by) });
    }
    util.qsa('hsc-delivery-estimate', this).forEach((el) => {
      const next = pre ? pre.preorder_ship_by : '';
      if ((el.dataset.preorder || '') !== next && el.closest('[data-delivery-box]')) {
        if (next) el.dataset.preorder = next; else delete el.dataset.preorder;
        if (typeof el.render === 'function') el.render();
      }
    });
    util.qsa('[data-color-note]', this).forEach((el) => { el.textContent = main.color_note || ''; });

    /* back in stock */
    const bisText = this.querySelector('[data-bis-text]');
    if (bisText) bisText.textContent = fmt(this.s.bis_text, { color: main.color });
    const tags = this.querySelector('[data-bis-tags]');
    if (tags) tags.value = [tags.dataset.base, `bis-${main.color_handle}`].filter(Boolean).join(',');
    const bis = this.querySelector('[data-bis]');
    if (bis) bis.hidden = !soldOut;
    if (!soldOut && notify) notify.setAttribute('aria-expanded', 'false');

    /* gallery */
    if (this.gallery && main.color_handle !== this.galleryColor && typeof this.gallery.showColor === 'function') {
      this.galleryColor = main.color_handle;
      this.gallery.showColor(main.color_handle, source !== 'init' ? fmt(this.s.showing_color, { color: main.color, count: '{count}' }) : '');
    }

    /* URL */
    if (this.hasAttribute('data-update-url') && (source === 'swatch' || source === 'unit')) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', main.id);
      try { window.history.replaceState(window.history.state, '', url.toString()); } catch (e) { /* ignore */ }
    }

    /* status region (debounced 400 ms) */
    if (source !== 'init') {
      clearTimeout(this.statusTimer);
      this.statusTimer = setTimeout(() => {
        const st = this.querySelector('[data-bundle-status]');
        if (!st) return;
        const tpl = n === 1 ? this.s.status_one : this.s.status;
        st.textContent = fmt(tpl, { tier: tierTitle.replace(/!$/, ''), count: n, colors: sum.spoken, total: money(totals.total) });
      }, 400);
    }

    this.state = { soldOut, invalid, totals, units, pre, main, sum, tierTitle };
    const detail = {
      sectionId: this.sid, productId: this.data.product_id, tier: this.tier, tierQty: n, tierTitle,
      units, colors: vs.map((v) => v.color), summary: sum.text, summarySpoken: sum.spoken,
      totals: { gross: totals.gross, free: totals.free, total: totals.total, each: totals.each, saving: totals.saving },
      valid: invalid < 0 && !soldOut, preorder: pre ? pre.preorder_ship_by : null, soldOut, image: main.image, unitPrice: unit, promo,
      pieces, limited: Boolean(promo && this.data.urgency && this.data.urgency.limited),
      mainColor: main.color, othersInStock
    };
    if (source === 'swatch' || source === 'unit' || source === 'init' || this.lastColor !== main.id) {
      HSC.bus.emit('variant:change', { sectionId: this.sid, productId: this.data.product_id, variant: main, color: main.color, source: source === 'unit' ? 'unit' : (source === 'swatch' ? 'swatch' : (source === 'init' ? 'init' : 'url')) });
      this.lastColor = main.id;
    }
    this.lastDetail = detail;
    HSC.bus.emit('bundle:change', detail);
  }

  /* ----- add to cart ----- */
  setLoading(on) {
    const btns = [this.atc, ...util.qsa(`hsc-sticky-atc[data-section-id="${this.sid}"] [data-sticky-add]`)].filter(Boolean);
    btns.forEach((b) => {
      b.classList.toggle('is-loading', on);
      if (on) { b.setAttribute('aria-disabled', 'true'); b.setAttribute('aria-busy', 'true'); }
      else { b.removeAttribute('aria-disabled'); b.removeAttribute('aria-busy'); }
    });
    const busy = this.atc && this.atc.querySelector('[data-atc-busy]');
    if (busy) busy.hidden = !on;
    this.busy = on;
  }

  showError(text) {
    const box = this.querySelector('[data-atc-error]');
    if (!box) return;
    const t = box.querySelector('[data-atc-error-text]');
    if (t) t.textContent = text || '';
    box.hidden = !text;
  }

  focusUnit(i) {
    const wrap = this.querySelector(`[data-tier-wrap="${this.tier}"]`);
    const row = wrap && wrap.querySelector(`[data-unit-row="${i}"]`);
    if (!row) return;
    const rows = row.closest('.bundle-picker__rows');
    if (rows) rows.hidden = false;
    HSC.scrollToTarget(row, { focus: row.querySelector('input:checked:not(:disabled)') || row.querySelector('input:not(:disabled)'), block: 'center' });
  }

  async submit(trigger, { single = false } = {}) {
    if (this.busy || !this.state) return;
    this.showError('');
    if (single) {
      const v = this.variants.get(this.units[0]);
      if (!this.isOrderable(v)) { this.focusUnit(0); return; }
    } else {
      if (this.state.soldOut) { this.openNotify(); return; }
      if (this.state.invalid >= 0) {
        this.notes = { error: this.state.invalid };
        this.render('validate');
        this.focusUnit(this.state.invalid);
        return;
      }
    }
    const ids = single ? [this.units[0]] : this.units.slice(0, this.tierQty);
    const conflict = this.cartConflict(ids);
    if (conflict) { this.showCartConflict(conflict); return; }
    const isSticky = trigger && trigger.closest && trigger.closest('hsc-sticky-atc');
    const opened = (msgCount) => {
      if (HSC.dialog.get('cart-drawer')) HSC.dialog.open('cart-drawer', { trigger: trigger || this.atc });
      else window.location.href = (HSC.config.routes && HSC.config.routes.cart) || ((HSC.config.routes && HSC.config.routes.root) || '/').replace(/\/?$/, '/') + 'cart';
      HSC.announce(util.plural({ one: HSC.strings.cart_added_one, other: HSC.strings.cart_added_other }, msgCount));
    };
    /* plan N9 (F6): a tap after an add whose answer was lost first checks whether that add reached the cart */
    if (this.pendingBundle) {
      const prev = this.pendingBundle;
      this.pendingBundle = null;
      this.setLoading(true);
      const found = await this.bundleInCart(prev.bundle).catch(() => false);
      if (found) {
        await HSC.cart.refresh().catch(() => {});
        this.setLoading(false);
        this.scheduleStock();
        opened(prev.count);
        return;
      }
      this.setLoading(false);
    }
    const bundle = `b1g1-${randomId()}`;
    const items = ids.map((id, i) => {
      const v = this.variants.get(id);
      const props = { _bundle: bundle, _tier: single ? '0' : String(this.tier), _unit: `${i + 1}/${ids.length}` };
      if (v && v.preorder_ship_by && this.s.ships_by_prop) props[this.s.ships_by_prop] = v.preorder_label || v.preorder_ship_by;
      return { id, quantity: 1, properties: props };
    });
    this.setLoading(true);
    try {
      const res = await this.addOnce(items, { source: single ? 'single' : (isSticky ? 'sticky' : 'pdp') }, bundle);
      if (res && res.recovered) this.scheduleStock();
      opened(items.length);
    } catch (err) {
      if (err && err.status === 422) await this.handleStockError(err, ids);
      else {
        if (this.isTransient(err)) this.pendingBundle = { bundle, count: items.length };
        this.showError(this.s.error);
      }
    } finally {
      this.setLoading(false);
    }
  }

  isTransient(err) {
    const st = err ? Number(err.status) : -1;
    return st === 0 || st === 429 || st >= 500;
  }

  async bundleInCart(bundle) {
    const cart = await HSC.cart.get();
    return Boolean(cart && Array.isArray(cart.items) && cart.items.some((it) => it.properties && it.properties._bundle === bundle));
  }

  scheduleStock() {
    clearTimeout(this.stockTimer);
    this.stockTimer = setTimeout(() => this.refreshStock(), 1500);
  }

  /** Plan N9 (F6, idempotent add): after a timeout / network error (status 0), a 429 or a 5xx the add may still have
      reached Shopify, so /cart.js is read first: a line with this add's _bundle id means it went through (the drawer is
      refreshed, never a second pair). Otherwise one retry after 1.2–2.0 s with the same items and _bundle, then the calm
      error with a working button. Never a loop; a 422 is handled by the stock path. */
  async addOnce(items, opts, bundle) {
    try {
      return await HSC.cart.add(items, opts);
    } catch (err) {
      if (!this.isTransient(err)) throw err;
      let found;
      try { found = await this.bundleInCart(bundle); } catch (e) { throw err; }
      if (found) {
        await HSC.cart.refresh().catch(() => {});
        HSC.track('hsc_atc_recovered', { status: Number(err.status) || 0 });
        return { recovered: true };
      }
      await new Promise((r) => { setTimeout(r, 1200 + Math.round(Math.random() * 800)); });
      return HSC.cart.add(items, opts);
    }
  }

  async handleStockError(err, ids) {
    try {
      const list = await this.fetchStock();
      if (list) list.forEach((fv) => { const v = this.variants.get(fv.id); if (v) { v.qty = fv.qty; v.available = fv.available; } });
    } catch (e) { /* keep old stock */ }
    try { await HSC.cart.get(); } catch (e) { /* keep the known cart */ }
    const i = this.firstInvalid();
    const conflict = i >= 0 ? null : this.cartConflict(ids || this.units.slice(0, this.tierQty));
    if (i >= 0) {
      this.notes = { error: i };
      this.render('validate');
      this.focusUnit(i);
    } else if (conflict) {
      this.showCartConflict(conflict);
    } else {
      this.render('validate');
      /* Shopify said there is not enough of something; with one color at the page's qty cap that color is the one */
      const capped = [...new Set((ids || []).map((id) => this.variants.get(id)).filter((v) => v && v.qty >= 8).map((v) => v.color))];
      this.showError(capped.length === 1 && this.s.cart_stock_error ? fmt(this.s.cart_stock_error, { color: capped[0], count: 0 }) : this.s.error);
    }
  }

  async addPairs(btn) {
    const id = Number(btn.dataset.variantId);
    if (!id || this.busy) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    try {
      const res = await HSC.cart.add([{ id, quantity: 1 }], { source: 'pairs' });
      if (HSC.dialog.get('cart-drawer')) HSC.dialog.open('cart-drawer', { trigger: btn });
      HSC.announce(util.plural({ one: HSC.strings.cart_added_one, other: HSC.strings.cart_added_other }, (res.items || []).length || 1));
    } catch (e) {
      this.showError(this.s.error);
    } finally {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    }
  }

  /* ----- back in stock ----- */
  openNotify(trigger) {
    const bis = this.querySelector('[data-bis]');
    if (!bis) return;
    bis.hidden = false;
    bis.dataset.open = 'true';
    const btn = trigger || this.querySelector('[data-notify-open]');
    if (btn && btn.hasAttribute('aria-controls')) btn.setAttribute('aria-expanded', 'true');
    const heading = bis.querySelector('[data-bis-heading]');
    HSC.scrollToTarget(bis, { focus: heading, block: 'center' });
  }

  async submitBis(e) {
    e.preventDefault();
    const form = e.target;
    const input = form.querySelector('[data-bis-email]');
    const fieldErr = form.querySelector('[data-bis-field-error]');
    const err = form.querySelector('[data-bis-error]');
    const email = input ? input.value.trim() : '';
    if (err) err.hidden = true;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
      if (fieldErr) fieldErr.hidden = false;
      return;
    }
    if (input) input.removeAttribute('aria-invalid');
    if (fieldErr) fieldErr.hidden = true;
    const v = this.variants.get(this.color);
    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.classList.add('is-loading');
    let ok = false;
    const key = HSC.config.klaviyo_public_key;
    if (key && v) {
      try {
        const res = await util.fetchWithTimeout(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(key)}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2024-10-15' },
          body: JSON.stringify({ data: { type: 'back-in-stock-subscription', attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email } } } }, relationships: { variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${v.id}` } } } } })
        });
        ok = res.ok || res.status === 409;
      } catch (x) { ok = false; }
    }
    if (!ok) {
      try {
        const res = await util.fetchWithTimeout(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } });
        if (res.url && res.url.indexOf('/challenge') > -1) { form.submit(); return; }
        ok = res.ok;
      } catch (x) { ok = false; }
    }
    if (submitBtn) submitBtn.classList.remove('is-loading');
    if (ok) {
      const success = this.querySelector('[data-bis-success]');
      form.hidden = true;
      if (success) { success.textContent = fmt(this.s.bis_success, { color: v ? v.color : '' }); success.hidden = false; }
      HSC.track('hsc_bis_submit', { color: v ? v.color : '' });
    } else if (err) {
      err.textContent = this.s.bis_error;
      err.hidden = false;
    }
  }
}

/* ---------- <hsc-gallery>: per-color groups on one scroll-snap track (SPEC D.1) ---------- */
class HscGallery extends HSC.Carousel {
  connectedCallback() {
    super.connectedCallback();
    this.thumbs = this.querySelector('[data-gallery-thumbs]');
    this.onThumb = (e) => {
      const a = e.target.closest('[data-thumb-index]');
      if (!a) return;
      e.preventDefault();
      this.goTo(Number(a.dataset.thumbIndex), { behavior: 'instant', announce: true });
    };
    this.onSlide = (e) => {
      /* Black Month: the two-line "50% OFF" sale chip (snippet sale-chip) collapses to one line after slide 1 */
      this.toggleAttribute('data-past-first', e.detail.index > 0);
      if (e.detail.index > 0) this.restoreDeferred();
      this.syncThumbs(e.detail.index);
      if (!this.resetting && e.detail.index > 0) HSC.track('hsc_gallery_swipe', { index: e.detail.index + 1 });
    };
    /* roving tabindex: one tab stop for the rail, arrow keys move between thumbs and sync the track */
    this.onThumbKey = (e) => {
      const cur = e.target.closest && e.target.closest('[data-thumb-index]');
      const group = cur && cur.closest('[data-thumb-group]');
      if (!group) return;
      const list = util.qsa('[data-thumb-index]', group);
      const k = list.indexOf(cur);
      const map = { ArrowDown: k + 1, ArrowRight: k + 1, ArrowUp: k - 1, ArrowLeft: k - 1, Home: 0, End: list.length - 1 };
      if (!(e.key in map)) return;
      e.preventDefault();
      const n = Math.max(0, Math.min(list.length - 1, map[e.key]));
      this.goTo(n, { behavior: 'instant', announce: true });
      this.syncThumbs(n);
      list[n].focus();
    };
    if (this.thumbs) {
      this.thumbs.addEventListener('click', this.onThumb);
      this.thumbs.addEventListener('keydown', this.onThumbKey);
    }
    this.addEventListener('carousel:change', this.onSlide);
    this.syncThumbs(this.index || 0);
    this.deferImages();
  }

  /* Plan N4 (F2, 26.10.2026): slides 2–n of the selected color ship with data-src / data-srcset / data-sizes (snippet
     gallery-groups), so only slide 1 competes with the LCP image. They get their real sources on the first touch, key
     or pointer press in the gallery, the first swipe, a color change, or once the page has loaded and the main thread
     is idle (1.5 s at most). With Save-Data on, only an interaction restores them. */
  deferImages() {
    if (!this.querySelector('img[data-defer-img]')) { this.restored = true; return; }
    this.onIntent = () => this.restoreDeferred();
    ['pointerdown', 'keydown'].forEach((t) => this.addEventListener(t, this.onIntent, { once: true }));
    this.addEventListener('touchstart', this.onIntent, { once: true, passive: true });
    if (util.saveData()) return;
    const idle = () => {
      if (this.restored) return;
      if ('requestIdleCallback' in window) window.requestIdleCallback(() => this.restoreDeferred(), { timeout: 1500 });
      else this.idleTimer = setTimeout(() => this.restoreDeferred(), 1500);
    };
    if (doc.readyState === 'complete') idle();
    else { this.onLoad = idle; window.addEventListener('load', this.onLoad, { once: true }); }
  }

  restoreDeferred() {
    if (this.restored) return;
    this.restored = true;
    clearTimeout(this.idleTimer);
    if (this.onLoad) window.removeEventListener('load', this.onLoad);
    if (this.onIntent) ['pointerdown', 'keydown', 'touchstart'].forEach((t) => this.removeEventListener(t, this.onIntent));
    util.qsa('img[data-defer-img]', this).forEach((img) => {
      const d = img.dataset;
      if (d.sizes) img.sizes = d.sizes;
      if (d.srcset) img.srcset = d.srcset;
      if (d.src) img.src = d.src;
      img.removeAttribute('data-defer-img');
      img.removeAttribute('data-sizes');
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-src');
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    clearTimeout(this.announceTimer);
    clearTimeout(this.idleTimer);
    if (this.onLoad) window.removeEventListener('load', this.onLoad);
    if (this.thumbs) {
      this.thumbs.removeEventListener('click', this.onThumb);
      this.thumbs.removeEventListener('keydown', this.onThumbKey);
    }
    this.removeEventListener('carousel:change', this.onSlide);
  }

  showColor(handle, announceTpl) {
    const groups = util.qsa('[data-color-group]', this);
    const target = groups.find((g) => g.dataset.colorGroup === handle);
    if (!target) return;
    this.expand(target);
    this.restoreDeferred();
    groups.forEach((g) => { g.hidden = g !== target; });
    util.qsa('[data-thumb-group]', this).forEach((g) => { g.hidden = g.dataset.thumbGroup !== handle; });
    this.resetting = true;
    if (this.track) this.reset();
    this.resetting = false;
    this.removeAttribute('data-past-first');
    this.syncThumbs(0);
    if (announceTpl) {
      /* debounced 300 ms; dropped when a modal (e.g. the cart drawer opened by a quick add) is open by then,
         so it never overwrites the drawer's "added to your cart" message */
      const msg = fmt(announceTpl, { count: target.dataset.count || this.slides.length });
      clearTimeout(this.announceTimer);
      this.announceTimer = setTimeout(() => {
        if (!util.qsa('dialog[open]').some((d) => !d.hasAttribute('data-dialog-modeless'))) HSC.announce(msg);
      }, 300);
    }
  }

  /** Hidden groups ship one 600 px source; build their srcset (same widths as the selected group) before use. */
  expand(group) {
    const widths = group && group.dataset.deferWidths;
    if (!widths) return;
    const list = widths.split(',').map((w) => w.trim()).filter(Boolean);
    util.qsa('img', group).forEach((img) => {
      const src = img.getAttribute('src') || '';
      if (!/[?&]width=\d+/.test(src)) return;
      img.srcset = list.map((w) => `${src.replace(/([?&]width=)\d+/, (m, key) => key + w)} ${w}w`).join(', ');
    });
    delete group.dataset.deferWidths;
  }

  prefetch(handle) {
    if (util.saveData()) return;
    const g = this.querySelector(`[data-color-group="${CSS.escape(handle)}"]`);
    this.expand(g);
    const img = g && g.querySelector('img');
    if (img && img.loading === 'lazy') img.loading = 'eager';
  }

  syncThumbs(i) {
    if (!this.thumbs) return;
    const group = util.qsa('[data-thumb-group]', this.thumbs).find((g) => !g.hidden);
    if (!group) return;
    const list = util.qsa('[data-thumb-index]', group);
    list.forEach((t, k) => {
      if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      t.setAttribute('tabindex', k === i ? '0' : '-1');
    });
    const active = list[i];
    if (!active || this.thumbs.offsetParent === null) return;
    const rail = this.thumbs;
    const vertical = rail.scrollHeight > rail.clientHeight + 1;
    if (vertical) {
      const top = active.offsetTop - rail.offsetTop;
      if (top < rail.scrollTop || top + active.offsetHeight > rail.scrollTop + rail.clientHeight) rail.scrollTo({ top: top - 8, behavior: 'instant' });
    } else {
      const left = active.offsetLeft - rail.offsetLeft;
      if (left < rail.scrollLeft || left + active.offsetWidth > rail.scrollLeft + rail.clientWidth) rail.scrollTo({ left: left - 8, behavior: 'instant' });
    }
  }
}

/* ---------- <hsc-sticky-atc> (SPEC D.19) ---------- */
class HscStickyAtc extends HTMLElement {
  connectedCallback() {
    this.sid = this.dataset.sectionId;
    this.mode = this.dataset.mode || 'after_atc';
    this.bar = this.querySelector('[data-sticky-bar]');
    this.product = this.closest('hsc-product');
    if (!this.bar || !this.product) return;
    this.flags = { atcVisible: true, atcAbove: false, offerAbove: false, picker: false, dialog: false, keyboard: false, editor: false };
    const atc = this.product.querySelector('[data-buy-actions]');
    const picker = this.product.querySelector('[data-bundle-picker]');
    /* QA 26.10.2026: `after_offer` shows the bar on phones once the offer box is above the viewport */
    this.offerBox = this.mode === 'after_offer' ? this.product.querySelector('.offer-box') : null;
    if (this.offerBox) {
      this.ioOffer = new IntersectionObserver((entries) => {
        entries.forEach((en) => { this.flags.offerAbove = !en.isIntersecting && en.boundingClientRect.top < 0; });
        this.update();
      }, { rootMargin: '0px 0px 100000px 0px' });
      this.ioOffer.observe(this.offerBox);
    }
    this.io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.target === atc) this.flags.atcVisible = en.isIntersecting;
        if (en.target === picker) this.flags.picker = en.isIntersecting;
      });
      this.update();
    });
    this.ioAbove = new IntersectionObserver((entries) => {
      entries.forEach((en) => { this.flags.atcAbove = !en.isIntersecting && en.boundingClientRect.top < 0; });
      this.update();
    }, { rootMargin: '0px 0px 100000px 0px' });
    if (atc) { this.io.observe(atc); this.ioAbove.observe(atc); }
    if (picker) this.io.observe(picker);
    this.offs = [
      HSC.bus.on('bundle:change', (d) => { if (d.sectionId === this.sid) this.fill(d); }),
      HSC.bus.on('dialog:open', () => { this.flags.dialog = true; this.update(); }),
      HSC.bus.on('dialog:closing', () => { this.flags.dialog = HSC.dialog.anyOpen(); this.update(); }),
      HSC.bus.on('dialog:close', (d) => this.onDialogClose(d)),
      HSC.bus.on('editor:section-select', (d) => { if (d.sectionId === this.sid) { this.flags.editor = true; this.update(); } }),
      HSC.bus.on('editor:section-deselect', (d) => { if (d.sectionId === this.sid) { this.flags.editor = false; this.update(); } })
    ];
    this.onViewport = () => {
      const vv = window.visualViewport;
      this.flags.keyboard = Boolean(vv && vv.height < window.innerHeight * 0.75);
      this.update();
    };
    if (window.visualViewport) window.visualViewport.addEventListener('resize', this.onViewport);
    this.onClick = (e) => {
      if (e.target.closest('[data-sticky-change]')) {
        const target = this.product.querySelector('[data-bundle-picker]') || this.product.querySelector('[data-buy-actions]');
        if (target) HSC.scrollToTarget(target, { focus: target.querySelector('input[data-tier]:checked') || target.querySelector('input:checked') });
        return;
      }
      const add = e.target.closest('[data-sticky-add]');
      if (!add) return;
      HSC.track('hsc_sticky_click', {});
      const st = this.product.state;
      if (st && st.soldOut) this.product.openNotify();
      else this.product.submit(add);
    };
    this.addEventListener('click', this.onClick);
    if (this.product.lastDetail) this.fill(this.product.lastDetail);
  }

  /* dialog:closing un-inerts the bar before global.js returns focus; this is the fallback when focus still got lost */
  onDialogClose(d) {
    this.flags.dialog = HSC.dialog.anyOpen();
    this.update();
    const dialog = d && d.dialog;
    const trigger = dialog && dialog._hscTrigger;
    if (this.flags.dialog || !trigger || !this.contains(trigger)) return;
    const active = doc.activeElement;
    const lost = !active || active === doc.body || active === doc.documentElement || dialog.contains(active);
    if (!lost) return;
    const atc = this.product.atc;
    const target = this.visible ? trigger : (atc && !atc.hidden ? atc : null);
    if (target) target.focus({ preventScroll: true });
  }

  disconnectedCallback() {
    if (this.io) this.io.disconnect();
    if (this.ioAbove) this.ioAbove.disconnect();
    if (this.ioOffer) this.ioOffer.disconnect();
    (this.offs || []).forEach((off) => off());
    if (window.visualViewport && this.onViewport) window.visualViewport.removeEventListener('resize', this.onViewport);
    this.removeEventListener('click', this.onClick);
    doc.documentElement.style.setProperty('--sticky-atc-h', '0px');
  }

  fill(d) {
    if (!d || !d.totals) return;
    this.lastDetail = d;
    const s = this.product.s || {};
    const q = (sel) => this.querySelector(sel);
    /* a sold-out color (an ad landing on ?variant=<sold-out color>, or a tap on its swatch): the bar names that color,
       never the in-stock units the picker moved to ("Sky Blue is sold out" / "Sky Blue", not "Sold out" / "Sand") */
    const tierEl = q('[data-sticky-tier]');
    if (tierEl) {
      if (d.soldOut && d.othersInStock && s.sold_out_color && d.mainColor) tierEl.textContent = fmt(s.sold_out_color, { color: d.mainColor });
      else if (d.soldOut && s.sold_out_status) tierEl.textContent = s.sold_out_status;
      else tierEl.textContent = d.tierTitle;
    }
    if (q('[data-sticky-total]')) q('[data-sticky-total]').textContent = money(d.totals.total);
    const ref = q('[data-sticky-ref]');
    if (ref) {
      ref.hidden = !(d.totals.free > 0);
      const strike = ref.querySelector('s');
      const qual = ref.querySelector('.sticky-atc__qual');
      if (strike) strike.textContent = money(d.totals.gross);
      if (qual) qual.textContent = fmt(s.ref_qualifier, { count: d.tierQty, unit: money(d.unitPrice) });
      const badge = ref.querySelector('[data-sticky-badge]');
      if (badge) {
        const text = typeof this.product.badgeText === 'function' ? this.product.badgeText(d.totals) : '';
        badge.textContent = text;
        badge.hidden = !text;
      }
    }
    if (q('[data-sticky-for]')) q('[data-sticky-for]').textContent = fmt(s.for_count, { count: d.tierQty });
    const colors = q('[data-sticky-colors]');
    if (colors) {
      const c = d.soldOut && d.mainColor ? d.mainColor : d.summary;
      colors.textContent = c;
      colors.title = d.soldOut && d.mainColor ? d.mainColor : d.summarySpoken;
    }
    const thumb = q('[data-sticky-thumb]');
    if (thumb && d.image && thumb.getAttribute('src') !== d.image) thumb.src = d.image;
    /* plan N14: the phone eyebrow carries the tier's sale badge ("BLACK MONTH · 50% OFF", nothing on a single blanket;
       the next line stays "Buy 1, get 1 free!") and the button names the selection like the main one ("Add 2 blankets – $89") */
    const pct = q('[data-sticky-label-pct]');
    if (pct) {
      const b = !d.soldOut && typeof this.product.badgeText === 'function' ? this.product.badgeText(d.totals) : '';
      pct.textContent = b ? `${s.list_separator || ' · '}${b}` : '';
      pct.hidden = !b;
    }
    const label = q('[data-sticky-btn-label]');
    const addTpl = (d.tierQty === 1 ? s.add_units_one : s.add_units_other) || s.add_to_cart_price;
    if (label) label.textContent = d.soldOut ? s.notify_me : (d.preorder ? s.preorder : (addTpl ? fmt(addTpl, { count: d.tierQty, price: money(d.totals.total) }) : s.add_to_cart));
    /* Black Month urgency strip: "Limited time · Limited pieces" (never a date, never a count) */
    const strip = q('[data-sticky-strip]');
    if (strip) {
      const lt = strip.querySelector('[data-sticky-strip-limited]');
      const sep = strip.querySelector('[data-sticky-strip-sep]');
      const st = strip.querySelector('[data-sticky-strip-pieces]');
      const hasLt = Boolean(d.limited && lt);
      const hasSt = Boolean(d.pieces && st);
      if (lt) lt.hidden = !hasLt;
      if (st) st.hidden = !hasSt;
      if (sep) sep.hidden = !(hasLt && hasSt);
      const was = strip.hidden;
      strip.hidden = !(hasLt || hasSt);
      if (was !== strip.hidden && this.visible) doc.documentElement.style.setProperty('--sticky-atc-h', `${this.bar.offsetHeight}px`);
    }
  }

  update() {
    const f = this.flags;
    const mobileAlways = this.mode === 'always_mobile' && util.isMobile();
    const afterOffer = Boolean(this.offerBox) && util.isMobile() && !this.offerBox.closest('[hidden]');
    const base = !f.dialog && !f.keyboard && !f.editor && !f.atcVisible;
    const show = afterOffer ? base && (f.offerAbove || f.atcAbove) : base && !f.picker && (mobileAlways || f.atcAbove);
    if (show === this.visible) return;
    this.visible = show;
    this.classList.toggle('is-visible', show);
    this.bar.inert = !show;
    this.bar.setAttribute('aria-hidden', String(!show));
    const h = show ? this.bar.offsetHeight : 0;
    doc.documentElement.style.setProperty('--sticky-atc-h', `${h}px`);
    HSC.bus.emit('sticky:change', { visible: show, height: h });
    if (show) HSC.trackOnce('hsc_sticky_view', {});
  }
}

/* ---------- <hsc-reels>: creator videos, one plays at a time, never under reduced motion / Save-Data ---------- */
class HscReels extends HTMLElement {
  connectedCallback() {
    this.videos = util.qsa('[data-reel-video]', this);
    this.auto = !util.reducedMotion() && !util.saveData();
    this.setBtn = (video) => {
      const tile = video.closest('[data-reel]');
      const play = tile && tile.querySelector('[data-reel-play]');
      const mute = tile && tile.querySelector('[data-reel-mute]');
      if (play) { play.dataset.state = video.paused ? 'paused' : 'playing'; play.setAttribute('aria-label', video.paused ? play.dataset.labelPlay : play.dataset.labelPause); }
      if (mute) { mute.dataset.state = video.muted ? 'muted' : 'sound'; mute.setAttribute('aria-label', video.muted ? mute.dataset.labelUnmute : mute.dataset.labelMute); }
    };
    this.playOnly = (video) => {
      this.videos.forEach((v) => { if (v !== video && !v.paused) v.pause(); });
      const p = video.play();
      if (p && p.catch) p.catch(() => {});
    };
    this.onMedia = (e) => { if (e.target.matches && e.target.matches('[data-reel-video]')) this.setBtn(e.target); };
    this.onClick = (e) => {
      const play = e.target.closest('[data-reel-play]');
      const mute = e.target.closest('[data-reel-mute]');
      const tile = (play || mute) && (play || mute).closest('[data-reel]');
      const video = tile && tile.querySelector('[data-reel-video]');
      if (!video) return;
      if (play) { if (video.paused) { video.dataset.user = 'play'; this.playOnly(video); } else { video.dataset.user = 'pause'; video.pause(); } }
      if (mute) { video.muted = !video.muted; this.setBtn(video); }
    };
    this.addEventListener('click', this.onClick);
    this.addEventListener('play', this.onMedia, true);
    this.addEventListener('pause', this.onMedia, true);
    if (this.auto && 'IntersectionObserver' in window) {
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          const v = en.target;
          if (en.intersectionRatio >= 0.5 && v.dataset.user !== 'pause') this.playOnly(v);
          else if (en.intersectionRatio < 0.5 && !v.paused) v.pause();
        });
      }, { threshold: [0, 0.5] });
      this.videos.forEach((v) => this.io.observe(v));
    }
  }

  disconnectedCallback() {
    if (this.io) this.io.disconnect();
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('play', this.onMedia, true);
    this.removeEventListener('pause', this.onMedia, true);
    (this.videos || []).forEach((v) => v.pause());
  }
}

define('hsc-gallery', HscGallery);
define('hsc-reels', HscReels);
define('hsc-sticky-atc', HscStickyAtc);
define('hsc-product', HscProduct);
